import { render, staticRenderFns } from "./ReportGeneratorResult.vue?vue&type=template&id=21564ef4&scoped=true&"
import script from "./ReportGeneratorResult.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneratorResult.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGeneratorResult.vue?vue&type=style&index=0&id=21564ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21564ef4",
  null
  
)

export default component.exports